import Header from 'components/Header';
import SafetyData from 'data/Safety';
import React from 'react';

export default function Safety() {
  return (
    <div className="">
      <Header />
      <main className="main SafetyPage">
        <div className="wrapper">
          <section className="section">
            <div className="section-intro">
              <div className="title">
                <h2>RAVEN LIVESTREAM POLICIES AND SAFETY GUIDELINES</h2>
                <br />
                <h2>VERSION 1.6, UPDATED JULY 2021</h2>
                <br />
              </div>
              <p className="body">
                When you use Raven Livestream, you join a community of people
                from all over the world. Every cool, new community feature on
                Raven Livestream involves a certain level of trust. Millions of
                users respect that trust and we trust you to be responsible too.
                Following the guidelines below helps to keep Raven Livestream
                fun and enjoyable for everyone. You might not like everything
                you see on Raven Livestream. If you think certain content is
                inappropriate, use the flagging/reporting feature to submit it
                for review by our Raven Livestream staff. Our staff carefully
                reviews flagged content 24 hours a day, 7 days a week to
                determine whether there&apos;s a violation of our Community
                Guidelines. Here are some common-sense rules that will help you
                steer clear of trouble. Please take these rules seriously and
                take them to heart. Don&apos;t try to look for loopholes or try
                to lawyer your way around the guidelines—just understand them
                and try to respect the spirit in which they were created.
              </p>
            </div>

            <div className="privacies">
              {SafetyData.map(({ title, content }) => (
                <div className="privacy-card" key={title}>
                  <h3>{title}</h3>
                  <p>{content}</p>
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}
